import type { FormFieldTypes } from './form-field-config';
import {
  validateDateField,
  validateAttachmentField,
  validateMultipleChoiceField,
  validateNumberField,
  validatePhoneField,
  validateTextField,
} from './validators/validators';
export const formFieldValidators: Record<FormFieldTypes, unknown> = {
  text: validateTextField,
  email: validateTextField,
  password: validateTextField,
  password_confirmation: validateTextField,
  dropdown: validateMultipleChoiceField,
  pp_dropdown: validateMultipleChoiceField,
  dropdowns_group: validateMultipleChoiceField,
  dropdown_with_other: validateMultipleChoiceField,
  checkboxes: validateMultipleChoiceField,
  radio_buttons: validateTextField,
  number: validateNumberField,
  phone_number: validatePhoneField,
  country: validateMultipleChoiceField,
  date: validateDateField,
  mastercard: validateTextField,
  favorite_player: validateMultipleChoiceField,
  one_club_free_text: undefined,
  undefined: undefined,
  password_with_confirm_and_multiple_validation: undefined,
  hidden_field_with_value: undefined,
  numbered_checkboxes: validateMultipleChoiceField,
  numbered_checkboxes_with_other: validateMultipleChoiceField,
  attachment: validateAttachmentField,
};
